<p-button
  label="戻る"
  class="nav-button"
  styleClass="p-button-secondary"
  icon="pi pi-arrow-left"
  iconPos="left"
  (click)="goBack()"></p-button>
<p-button
  label="新規カテゴリ追加"
  class="nav-button"
  styleClass="p-button-primary"
  icon="pi pi-file"
  iconPos="left"
  (click)="showTypeDialog()"></p-button>

<div class="grid">
  <div class="col-12"></div>
  <div class="col-1"></div>

  <div class="col-10">
    @for (type of types; track type) {
      <p-fieldset>
        <ng-template #header>{{ type.name }}</ng-template>
        <div class="grid">
          <div class="col-9">
            @for (store of type.stores; track store) {
              <p-button
                [style]="{ margin: '0.3rem' }"
                label="{{ store.name }}"
                styleClass="p-button-success p-button-sm p-button-raised p-button-rounded"
                iconPos="right"
                pDraggable="{{ type.name }}"
                pDroppable="{{ type.name }}"
                (onDragStart)="dragStart(type, store)"
                (onDrop)="drop(store)"
                (onDragEnter)="dragEnter(store)"
                (onDragEnd)="dragEnd(store)"
                pTooltip="{{ tooltipMessage }}"></p-button>
            }
          </div>
          <div class="col-2">
            <p-button
              label="店舗追加"
              styleClass="p-button-primary p-button-sm p-button-raised p-button-rounded"
              iconPos="left"
              (click)="showStoreDialog(type.id)"></p-button>
            <br />
            <br />
            <p-button
              label="店舗削除"
              styleClass="p-button-danger p-button-sm p-button-raised p-button-rounded"
              iconPos="left"
              icon="pi pi-trash"
              disabled="true"
              pDroppable="{{ type.name }}"
              (onDrop)="dropDeleteStore()"></p-button>
            <br />
            @if (canDeleteType(type)) {
              <span>
                <p-button
                  label="カテゴリ削除"
                  styleClass="p-button-danger p-button-sm p-button-raised p-button-rounded"
                  iconPos="left"
                  (click)="deleteType(type.id)"></p-button>
              </span>
            }
          </div>
          <div class="col-1 center">
            @if (!isFirstType(type)) {
              <button
                pButton
                iconOnly
                pRipple
                (click)="movePrev(type)"
                type="button"
                class="p-button-rounded p-button-info">
                <i
                  class="pi pi-arrow-up"
                  aria-hidden="true"></i>
              </button>
            }
            <br />
            <br />
            @if (!isLastType(type)) {
              <button
                pButton
                iconOnly
                pRipple
                (click)="moveNext(type)"
                type="button"
                class="p-button-rounded p-button-info">
                <i
                  class="pi pi-arrow-down"
                  aria-hidden="true"></i>
              </button>
            }
          </div>
        </div>
      </p-fieldset>
    }
  </div>
  <div class="col-1"></div>
</div>

<p-dialog
  header="新規のカテゴリを追加"
  [(visible)]="displayTypeDialog"
  [modal]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false">
  <br />
  <div class="p-fluid">
    <p-floatlabel>
      <input
        id="category-name"
        type="text"
        pInputText
        [(ngModel)]="categoryName" />
      <label for="category-name">新規カテゴリ名</label>
    </p-floatlabel>
  </div>

  <ng-template #footer>
    <p-button
      (click)="displayTypeDialog = false"
      label="キャンセル"
      styleClass="p-button-danger"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="registerStoreType(categoryName)"
      label="登録"
      styleClass="p-button-primary"></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  header="新規の店舗を追加"
  [(visible)]="displayStoreDialog"
  [modal]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false">
  <br />
  <div class="p-fluid">
    <p-floatlabel>
      <label for="store-name">新規の店舗名</label>
      <input
        id="store-name"
        type="text"
        pInputText
        [(ngModel)]="storeName" />
    </p-floatlabel>
  </div>

  <ng-template #footer>
    <p-button
      (click)="displayStoreDialog = false"
      label="キャンセル"
      styleClass="p-button-danger"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="registerStore()"
      label="登録"
      styleClass="p-button-primary"></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  header="店舗削除確認"
  [(visible)]="displayDeleteStoreDialog"
  [modal]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false">
  <b>{{ deleteStoreName }}</b>
  を削除してもよいでしょうか？
  <ng-template #footer>
    <p-button
      (click)="displayDeleteStoreDialog = false"
      label="キャンセル"
      styleClass="p-button-danger"></p-button>
    <p-button
      icon="pi pi-check"
      (click)="deleteStore()"
      label="削除"
      styleClass="p-button-primary"></p-button>
  </ng-template>
</p-dialog>
